<div class="hours-card">
  <div class="legend-container">
    <div class="legend" *ngFor="let legend of legendData">
      <div class="dot" [ngStyle]="{ background: legend?.color }"></div>
      <label>{{ legend?.text }}</label>
    </div>
  </div>
  <div class="chart">
    <!-- <app-donut-percentage-chart
      [multiText]="true"
      [donutChartData]="billableHoursChartData"
      [width]="width"
      [height]="height"
    ></app-donut-percentage-chart> -->
    <div class="content">
      <label>Total</label>
      <div><strong>{{this.total}}</strong><span>hrs</span></div>
    </div>
    <app-donut-chart
      *ngIf="initializeChart"
      [donutChartData]="billableHoursChartData"
      [name]="'billableHours'"
      [width]="width"
      [height]="height"
    ></app-donut-chart>
  </div>
</div>
